import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Alert, Spinner } from "reactstrap";

const JobApplicationForm = ({ data }) => {
    // Use react-hook-form for state management and validation
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: "onBlur"
    });

    const isAadharInputRequired = data.Country !== 'US';
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                reject(new Error('No file provided'));
                return;
            }
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const generateHtmlTable = (formData) => {
        let tableHtml = "<table style='font-family: \"Google Sans\" '>";
        tableHtml += '<thead><tr><td colspan="2" style="font-size: 16px; border-bottom: 1px solid #000;">Job Application</td></tr></thead>';
        tableHtml += '<tbody>';
        tableHtml += `<tr><td><b>First Name:</b></td><td>${formData.firstName}</td></tr>`;
        tableHtml += `<tr><td><b>Last Name:</b></td><td>${formData.lastName}</td></tr>`;
        tableHtml += `<tr><td><b>Email:</b></td><td>${formData.Email}</td></tr>`;
        tableHtml += `<tr><td><b>Mobile:</b></td><td>${formData.Mobile}</td></tr>`;
        tableHtml += `<tr><td><b>Address:</b></td><td>${formData.Address}</td></tr>`;
        tableHtml += `<tr><td><b>Current Salary:</b></td><td>${formData.CurrentSalary}</td></tr>`;
        tableHtml += `<tr><td><b>Expected Salary:</b></td><td>${formData.ExpectedSalary}</td></tr>`;
        tableHtml += '</tbody></table>';
        return tableHtml;
    };

    // The function to handle form submission
    const onSubmit = async (formData) => {
        setLoading(true);
        setErrorMessage('');
        let base64Resume, base64Aadhar;
        let attachments = [];

        try {
            // Handle file conversions
            base64Resume = await getBase64(formData.Resume[0]);
            attachments.push({
                name: formData.Resume[0].name,
                data: base64Resume
            });

            if (isAadharInputRequired && formData.Aadhar && formData.Aadhar[0]) {
                base64Aadhar = await getBase64(formData.Aadhar[0]);
                attachments.push({
                    name: formData.Aadhar[0].name,
                    data: base64Aadhar
                });
            }

            const config = {
                SecureToken: "118c3d49-ce2a-4e28-998f-cb1a17538acd",
                To: 'careers@tetrahed.com',
                From: "careers@tetrahed.com",
                Subject: `Job application for ${data.Role}`,
                Body: generateHtmlTable(formData),
                Attachments: attachments
            };

            const message = await window.Email.send(config);

            if (message === 'OK') {
                reset(); // Reset form using react-hook-form's reset
                setFormSubmitted(true);
            } else {
                setErrorMessage(message || 'Oops something went wrong, please try after sometime');
            }
        } catch (error) {
            setErrorMessage(error.message || 'Oops something went wrong');
            console.error('Error sending email:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
            {formSubmitted ? (
                <div className="successDiv text-center">
                    <img className="pulse" width="96" height="96"
                         src="https://img.icons8.com/color/96/verified-account--v1.png"
                         alt="verified-account--v1"/>
                    <h5 style={{ padding: '24px' }}>
                        Your application is submitted! <br/> We will get in touch soon!
                    </h5>
                </div>
            ) : (
                <div className="InputFieldSection mt-4">
                    {/* Use handleSubmit from react-hook-form */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <section className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="firstName">First Name<span className="text-danger">*</span></label>
                                {/* Use spread operator for register */}
                                <input type="text" id="firstName" maxLength="40"
                                       {...register("firstName", { required: 'First Name is required' })} />
                                <small className="text-danger">
                                    {errors.firstName && <p>{errors.firstName.message}</p>}
                                </small>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="lastName">Last Name<span className="text-danger">*</span></label>
                                <input type="text" id="lastName" maxLength="40"
                                       {...register("lastName", { required: 'Last Name is required' })} />
                                <small className="text-danger">
                                    {errors.lastName && <p>{errors.lastName.message}</p>}
                                </small>
                            </div>
                        </section>
                        <section className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="Mobile">Mobile Number<span className="text-danger">*</span></label>
                                <input type="tel" id="Mobile" maxLength="12" minLength="10"
                                       {...register("Mobile", { required: 'Mobile Number is required' })} />
                                <small className="text-danger">
                                    {errors.Mobile && <p>{errors.Mobile.message}</p>}
                                </small>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="Email">Email<span className="text-danger">*</span></label>
                                <input type="email" id="Email"
                                       {...register("Email", {
                                           required: 'Email is required',
                                           pattern: {
                                               value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                               message: "Invalid email address"
                                           }
                                       })} />
                                <small className="text-danger">
                                    {errors.Email && <p>{errors.Email.message}</p>}
                                </small>
                            </div>
                        </section>
                        <section className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="CurrentSalary">Current Salary <small className="text-muted">(In LPA)</small></label>
                                <input type="text" id="CurrentSalary" maxLength="10" {...register("CurrentSalary")} />
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="ExpectedSalary">Expected Salary <small className="text-muted">(In LPA)</small></label>
                                <input type="text" id="ExpectedSalary" {...register("ExpectedSalary")} />
                            </div>
                        </section>
                        <section className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                <label htmlFor="Address">Address<span className="text-danger">*</span></label>
                                <input type="text" id="Address" maxLength="150"
                                       {...register("Address", { required: 'Address is required' })} />
                                <small className="text-danger">
                                    {errors.Address && <p>{errors.Address.message}</p>}
                                </small>
                            </div>
                        </section>
                        <section className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 mb-8">
                                <label htmlFor="Resume">Resume<span className="text-danger">*</span>
                                    <div style={{ borderRadius: '6px', padding: '12px', background: 'whitesmoke', border: '2px dashed' }}>
                                        <input type="file" id="Resume" accept=".doc, .docx"
                                               {...register("Resume", { required: "Resume is required" })} />
                                    </div>
                                </label>
                                <small className="text-danger">
                                    {errors.Resume && <p>{errors.Resume.message}</p>}
                                </small>
                            </div>
                            {isAadharInputRequired &&
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-8">
                                    <label htmlFor="Aadhar">Aadhar
                                        <div style={{ borderRadius: '6px', padding: '12px', background: 'whitesmoke', border: '2px dashed' }}>
                                            <input type="file" id="Aadhar" {...register("Aadhar")} />
                                        </div>
                                    </label>
                                </div>
                            }
                        </section>

                        <div id="globalErrStrip">
                            {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                        </div>
                        <div className="col-sm-12 col-xs-12 text-right mb-4">
                            <button type="submit" disabled={loading} className="btn btn-brand-color btn-hover-secondary">
                                {loading ? <Spinner color="light">Loading...</Spinner> : 'Apply'}
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
}

export default JobApplicationForm;
